import React, { useEffect, useRef } from "react";

export default function CanvasTest(){

    const colorArray = ['--ink-black','--dusty-grape','--deep-sky-blue','--gunmetal'];
    
    const canvasRef = useRef(null);
    const mouseRef = useRef({ x: 0, y: 0 });
    const prevMouseRef = useRef({ x: 0, y: 0 }); 
    const particlesRef = useRef([]);

    const inActiveIntervalRef = useRef(null);
    const idleParticleTimeoutRef = useRef(null);

    const resizeFunction = () => {
        const canvas = canvasRef.current;
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    };

    const startIdleParticles = (startTime,Interval) => {
        inActiveIntervalRef.current = setTimeout(() => {
            idleParticleTimeoutRef.current = setInterval(() => {
                idleParticleFunction();
            },Interval);
        },startTime);
    }

    const stopIdleParticles = () => {
        clearInterval(idleParticleTimeoutRef.current)
        clearTimeout(inActiveIntervalRef.current);
    }

    const mouseMoveFunc = (e) => {
        stopIdleParticles();
        startIdleParticles(2000,100);
        const rect = canvasRef.current.getBoundingClientRect();
        mouseRef.current = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };

        // Create particle on mouse move
        if(Math.abs(mouseRef.current.x - prevMouseRef.current.x) > 30 || Math.abs(mouseRef.current.y - prevMouseRef.current.y) > 30){
            prevMouseRef.current = mouseRef.current;
            particlesRef.current.push(new Particle());
        }
    };

    class Particle {
        constructor(){
            this.x = mouseRef.current.x;
            this.y = mouseRef.current.y;
            this.size = Math.random() * 50 + 1;
            this.speedX = (Math.random() * 1 - 0.5) * 3;
            this.speedY = (Math.random() * 1 - 0.5) * 3;
            this.color = colorArray[Math.floor(Math.random()*colorArray.length)];
        }

        update(){
            this.x += this.speedX;
            this.y += this.speedY;
            this.size *= 0.99;
        }

        draw(ctx){
            var r = document.querySelector(':root');
            var rs = getComputedStyle(r);
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fillStyle = rs.getPropertyValue(this.color);
            ctx.fill();
        }
    }

    class Particle2 {
        constructor(posX,posY){
            this.x = posX;
            this.y = posY;
            this.size = Math.random() * 50 + 1;
            this.speedX = (Math.random() * 1 - 0.5) * 3;
            this.speedY = (Math.random() * 1 - 0.5) * 3;
            this.color = colorArray[Math.floor(Math.random()*colorArray.length)];
        }

        update(){
            this.x += this.speedX;
            this.y += this.speedY;
            this.size *= 0.99;
        }

        draw(ctx){
            var r = document.querySelector(':root');
            var rs = getComputedStyle(r);
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fillStyle = rs.getPropertyValue(this.color);
            ctx.fill();
        }
    }

    const animate = () => {
        const canvas = canvasRef.current;
        if(canvas){
            const ctx = canvas.getContext("2d");
    
            ctx.clearRect(0, 0, canvas.width, canvas.height);
    
            particlesRef.current.forEach((particle, index) => {
                particle.update();
                particle.draw(ctx);
    
                if (particle.size < 0.5) {
                    particlesRef.current.splice(index, 1);
                }
            });
    
            requestAnimationFrame(animate);

        }
    };

    const idleParticleFunction = () => {
        const canvas = canvasRef.current;
        const posX = Math.floor(Math.random()*canvas.width);
        const posY = Math.floor(Math.random()*canvas.height);
        particlesRef.current.push(new Particle2(posX,posY));
    }

    useEffect(() => {
        resizeFunction();
        animate();

        startIdleParticles(0,100);

        window.addEventListener("resize", resizeFunction);
        window.addEventListener("mousemove", mouseMoveFunc);

        return () => {
            stopIdleParticles();
            window.removeEventListener("resize", resizeFunction);
            window.removeEventListener("mousemove", mouseMoveFunc);
        };
    }, []);

    return <canvas ref={canvasRef} />;
}
